import { audioMessage as message } from "../../Components/Common/Notifications/audioMessage";
import { TrainingAPI } from "../../api/TrainingAPI";
import {mapDataForHighchartsGroupedBar} from "../../mappers/model/GroupedBarChartMapper"
import { displayValidationErrorMessages } from "@components/Common/Notifications/teamValidation";
import { getCurrentUserData } from "./auth.actions";
import { DATA_STREAM_PERMISSIONS, hasDataPermission } from "@utils/data_access";
const trainingAPI = new TrainingAPI();

export const TEAM_SET_LOADING = "[TEAM]_SET_LOADING";
export const TEAM_SET_METRIC_DROPDOWNS = '[TEAM]_TEAM_SET_METRIC_DROPDOWNS';
export const TEAM_SET_TESTING_DROPDOWNS = '[TEAM]_SET_TESTING_DROPDOWNS';
export const TEAM_SET_FORCEPLATE_DROPDOWNS = '[TEAM]_SET_FORCEPLATE_DROPDOWNS';
export const TEAM_SET_TEAM_BASIC_INFO = "[TEAM]_SET_TEAM_BASIC_INFO";
export const TEAM_SET_ALL_TEAM_METRICS = "[TEAM]_SET_ALL_TEAM_METRICS";
export const TEAM_SET_POSITIONS = "[TEAM]_SET_POSITIONS";
export const TEAM_SET_ALL_POSITIONS = "[TEAM]_SET_ALL_POSITIONS";
export const TEAM_SET_POSITION_ENTITIES = "[TEAM]_SET_POSITION_ENTITIES";
export const TEAM_SET_SPORT = "[TEAM]_SET_SPORT";
export const TEAM_SET_MISC_CONSTANTS = "[TEAM]_SET_MISC_CONSTANTS";
export const TEAM_SET_PLAYERS = "[TEAM]_SET_PLAYERS";
export const TEAM_SET_GAMES = "[TEAM]_SET_GAMES";
export const TEAM_SET_METRICS = "[TEAM]_SET_METRICS";
export const TEAM_SET_COLOR_REF = "[TEAM]_SET_COLOR_REF";
export const TEAM_SET_HAS_WELLNESS = "[TEAM]_SET_HAS_WELLNESS";
export const TEAM_SET_INFORMATION = "[TEAM]_SET_INFORMATION";
export const TEAM_SET_FILTERS = "[TEAM]_SET_FILTERS";
export const TEAM_SET_TRAININGS = "[TEAM]_SET_TRAININGS";
export const TEAM_SET_PRACTICE_PLAN = "[TEAM]_SET_PRACTICE_PLAN";
export const TEAM_SET_DRILL_COST_PER_MIN = "[TEAM]_SET_DRILL_COST_PER_MIN";
export const TEAM_SET_DRILLS = "[TEAM]_SET_DRILLS";
export const TEAM_SET_DATED_DRILLS = "[TEAM]_SET_DATED_DRILLS";
export const TEAM_SET_OVERVIEW_STATS = "[TEAM]_SET_OVERVIEW_STATS";
export const TEAM_SET_CHARTS = "[PLAYER]_PLAYER_SET_CHARTS";
export const TEAM_SET_TESTING_STATS = "[TEAM]_SET_TESTING_STATS";
export const TEAM_SET_TESTING_STAT_DEFAULTS =
	"[TEAM]_SET_TESTING_STAT_DEFAULTS";
export const TEAM_SET_PLAYER_PROFILE_STAT_DEFAULTS =
	"[TEAM]_SET_PLAYER_PROFILE_STAT_DEFAULTS";
export const TEAM_SET_FORCEPLATE_STAT_DEFAULTS =
	"[TEAM]_SET_FORCEPLATE_STAT_DEFAULTS";
export const TEAM_SET_WELLNESS_STAT_DEFAULTS =
	"[TEAM]_SET_WELLNESS_STAT_DEFAULTS";
export const TEAM_SET_GPS_STAT_DEFAULTS = "[TEAM]_SET_GPS_STAT_DEFAULTS";
export const TEAM_SET_NUTRITION_STAT_DEFAULTS = "[TEAM]_SET_NUTRITION_STAT_DEFAULTS";
export const TEAM_SET_COGNITION_STAT_DEFAULTS = "[TEAM]_SET_COGNITION_STAT_DEFAULTS";
export const TEAM_SET_TESTING_DATA = "[TEAM]_SET_TESTING_DATA";
export const TEAM_SET_TESTING_RARDAR_METRICS =
	"[TEAM]_SET_TESTING_RADAR_METRICS";
export const TEAM_SET_TESTING_RADAR_DATA = "[TEAM]_SET_TESTING_RADAR_DATA";
export const TEAM_SET_TESTING_TABLE_DATA = "[TAEM]_SET_TESTING_TABLE_DATA";
export const TEAM_SET_PLAYER_GROUPS = "[TEAM]_SET_PLAYER_GROUPS";
export const TEAM_SET_SESSIONS = "[TEAM]_SET_SESSIONS";
export const TEAM_SET_FP_DATA = "[TEAM]_SET_FP_DATA";
export const TEAM_SET_FPMS_DATA = "[TEAM]_SET_FPMS_DATA";
export const TEAM_SET_FP_METRICS = "[TEAM]_SET_FP_METRICS";
export const TEAM_SET_REST_TRAVEL_DATES = "[TEAM]_SET_REST_TRAVEL_DATES";
export const TEAM_SET_ALL_PLAYERS = "[TEAM]_SET_ALL_PLAYERS";
export const TEAM_SET_PLAYERS_STATUS = "[TEAM]_SET_PLAYERS_STATUS";
export const TEAM_SET_PRESETS = "[TEAM]_SET_PRESETS";
export const TEAM_SET_SANDBOX_DASHBOARDS = "[TEAM]_SET_SANDBOX_DASHBOARDS";

export const TEAM_SET_SCATTERPLOT_FILTERS = "[TEAM]_SET_SCATTERPLOT_FILTERS";
export const TEAM_SET_SCATTERPLOT_DATA = "[TEAM]T_SET_SCATTERPLOT_DATA";
export const TEAM_SET_SCATTERPLOT_ERROR = "[TEAM]_SET_SCATTERPLOT_ERROR";

export const TEAM_SET_PROFILE_PRESET_NAME = "[TEAM]_SET_PROFILE_PRESET_NAME"
export const TEAM_SET_COLOR_STRATEGIES = "[TEAM]_SET_COLOR_STRATEGIES"
export const TEAM_SET_USER_DEFINED_METRICS = "[TEAM]_SET_USER_DEFINED_METRICS"

export const TEAM_SET_ALL_GPS_METRICS = "[TEAM]_SET_ALL_GPS_METRICS"
export const TEAM_SET_TESTING_METRIC_NAMES = "[TEAM]_SET_TESTING_METRIC_NAMES"

export const CALENDAR_TAGS_SET = "[TEAM]_CALENDAR_TAGS_SET";
export const CALENDAR_DAY_TAGS_SET = "[TEAM]_CALENDAR_DAY_TAGS_SET";
export const TEAM_SET_PERMISSION_USERS = "[TEAM]_SET_PERMISSION_USERS";

export const setProfilePresetName = (presetName) => {
	return {
		type: TEAM_SET_PROFILE_PRESET_NAME,
		data: presetName
	}
}

export const setTeamLoading = (data) => {
	return {
		type: TEAM_SET_LOADING,
		data,
	};
};

export const setMetricDropdowns = (metricType, data) => ({
  type: TEAM_SET_METRIC_DROPDOWNS,
  payload: { metricType, data }
});

export const setTestingDropdowns = (data) => ({
  type: TEAM_SET_TESTING_DROPDOWNS,
  payload: data
});

export const setForceplateDropdowns = (data) => ({
  type: TEAM_SET_FORCEPLATE_DROPDOWNS,
  payload: data
});

export const setTeamInfo = (data) => {
	return {
		type: TEAM_SET_TEAM_BASIC_INFO,
		data,
	};
};

export const setTeamSessions = (data) => {
	return {
		type: TEAM_SET_SESSIONS,
		data,
	};
};

export const setAllTeamMetrics = (data) => {
	return {
		type: TEAM_SET_ALL_TEAM_METRICS,
		data,
	};
};

export const setTeamPositions = (data) => {
	return {
		type: TEAM_SET_POSITIONS,
		data,
	};
};

export const setTeamSport = (data) => {
	return {
		type: TEAM_SET_SPORT,
		data,
	};
};

export const setAllPositions = (data) => {
	return {
		type: TEAM_SET_ALL_POSITIONS,
		data,
	};
};

export const setPositionEntities = (data) => ({
	type: TEAM_SET_POSITION_ENTITIES,
	data,
});

export const setTeamPlayers = (data) => {
	return {
		type: TEAM_SET_PLAYERS,
		data,
	};
};

export const setTeamGames = (data) => {
	return {
		type: TEAM_SET_GAMES,
		data,
	};
};

export const setTeamMetrics = (data) => {
	return {
		type: TEAM_SET_METRICS,
		data,
	};
};

export const setTeamColorRefs = (data) => {
	return {
		type: TEAM_SET_COLOR_REF,
		data,
	};
};

export const setTeamHasWellness = (data) => {
	return {
		type: TEAM_SET_HAS_WELLNESS,
		data,
	};
};

export const setTeamInformation = (data) => {
	return {
		type: TEAM_SET_INFORMATION,
		data,
	};
};

export const setTeamFilter = (data) => {
	return {
		type: TEAM_SET_FILTERS,
		data,
	};
};

export const setTeamTrainings = (data) => {
	return {
		type: TEAM_SET_TRAININGS,
		data,
	};
};

export const setTeamPracticePlan = (data) => {
	return {
		type: TEAM_SET_PRACTICE_PLAN,
		data,
	};
};

export const setTeamDrillCostPerMin = (data) => {
	return {
		type: TEAM_SET_DRILL_COST_PER_MIN,
		data,
	};
};

export const setTeamDrills = (data) => {
	return {
		type: TEAM_SET_DRILLS,
		data,
	};
};

export const setTeamDatedDrills = (data) => {
	return {
		type: TEAM_SET_DATED_DRILLS,
		data,
	};
};

export const setTeamTestingStats = (data) => {
	return {
		type: TEAM_SET_TESTING_STATS,
		data,
	};
};

export const setTestingStatDefaults = (data) => {
	return {
		type: TEAM_SET_TESTING_STAT_DEFAULTS,
		data,
	};
};

export const setForceplateStatDefaults = (data) => {
	return {
		type: TEAM_SET_FORCEPLATE_STAT_DEFAULTS,
		data,
	};
};

export const setPlayerProfileStatDefaults = (data) => {
	return {
		type: TEAM_SET_PLAYER_PROFILE_STAT_DEFAULTS,
		data,
	};
};

export const setWellnessStatDefaults = (data) => {
	return {
		type: TEAM_SET_WELLNESS_STAT_DEFAULTS,
		data,
	};
};

export const setGPSStatDefaults = (data) => {
	return {
		type: TEAM_SET_GPS_STAT_DEFAULTS,
		data,
	};
};

export const setNutritionStatDefaults = (data) => {
	return {
		type: TEAM_SET_NUTRITION_STAT_DEFAULTS,
		data,
	};
};

export const setCognitionStatDefaults = (data) => {
	return {
		type: TEAM_SET_COGNITION_STAT_DEFAULTS,
		data,
	};
};

export const setTeamTestingData = (data) => {
	return {
		type: TEAM_SET_TESTING_DATA,
		data,
	};
};

export const setTeamTestingRadarMetrics = (data) => {
	return {
		type: TEAM_SET_TESTING_RARDAR_METRICS,
		data,
	};
};

export const setTeamTestingRadarData = (data) => {
	return {
		type: TEAM_SET_TESTING_RADAR_DATA,
		data,
	};
};

export const setTeamTestingTableData = (data) => {
	return {
		type: TEAM_SET_TESTING_TABLE_DATA,
		data,
	};
};

export const setTeamPlayerGroups = (data) => {
	return {
		type: TEAM_SET_PLAYER_GROUPS,
		data,
	};
};
export const setTeamFPData = (data) => {
	return {
		type: TEAM_SET_FP_DATA,
		data,
	};
};

export const setTeamFPMSData = (data) => {
  return {
    type: TEAM_SET_FPMS_DATA,
    data,
  };
};

export const setTeamFPMetrics = (data) => {
	return {
		type: TEAM_SET_FP_METRICS,
		data,
	};
};

export const setTeamRestTravelDates = (data) => {
	return {
		type: TEAM_SET_REST_TRAVEL_DATES,
		data,
	};
};

export const setTeamAllPlayers = (data) => {
	return {
		type: TEAM_SET_ALL_PLAYERS,
		data,
	};
};

export const setPlayerStatus = (data) => {
	return {
		type: TEAM_SET_PLAYERS_STATUS,
		data,
	};
}

export const setTeamOverviewStats = (data) => {
	return {
		type: TEAM_SET_OVERVIEW_STATS,
		data,
	};
};

export const getTeamPlayers = () => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ players: true }));
		try {
			const players = await trainingAPI.getAllPlayers(true);
			await dispatch(
				setTeamPlayers(players.filter(({ retired }) => !retired))
			);
			await dispatch(setTeamAllPlayers(players));
		} catch (e) {
			console.error(e);
		}
		await dispatch(setTeamLoading({ players: false }));
	};
};

export const getPlayerStatus = () => {
	return async (dispatch) => {
		try {
		const data = await trainingAPI.getAllPlayerStatus();

		dispatch(setPlayerStatus(data));
		} catch (error) {
		console.error('Failed to fetch testing dropdowns:', error);
		}
	};
}


export const getTestingDropdowns = () => {
  return async (dispatch, getState) => {
    try {
      const data = await trainingAPI.getDropdowns({ 
        metricType: ['testing'] 
      });
      if (data.testing_tree) {
        dispatch(setTestingDropdowns(data.testing_tree));
      }
    } catch (error) {
      console.error('Failed to fetch testing dropdowns:', error);
    }
  };
};

export const getForceplateDropdowns = () => {
  return async (dispatch, getState) => {
    try {
      const data = await trainingAPI.getDropdowns({ 
        metricType: ['forceplate'] 
      });
      if (data.forceplate_tree) {
        dispatch(setForceplateDropdowns(data.forceplate_tree));
      }
    } catch (error) {
      console.error('Failed to fetch forceplate dropdowns:', error);
    }
  };
};

export const getTeamInfo = () => async (dispatch) => {
	try {
		const info = await trainingAPI.getTeamInfo();
		dispatch(setTeamInfo(info));
		if (info && Object.keys(info).length > 0 && 'team_colors' in info) {
			dispatch(setTeamColorRefs(info.team_colors));
		}
	} catch (e) {
		throw e;
	}
};

export const getAllTeamMetricsByType = () => async (dispatch) => {
	try {
		const info = await trainingAPI.getTeamMetrics(
			true,
			true,
			true,
			true,
			true,
			"all_gps",
			false,
			// Counts are always requested. The backend returns none until its own gate
			// opens, and the dropdown gates on the experimental flag — so toggling that
			// flag shows them at once instead of waiting for the next fetch.
			true,
			true
		);
		dispatch(setTeamMetrics(info?.filter((x) => x.metric_type === "gps")));
		dispatch(setAllTeamMetrics(info));
	} catch (e) {
		throw e;
	}
};

export const getTeamDrills = () => async (dispatch) => {
	try {
		const drills = await trainingAPI.getDrills();
		await dispatch(setTeamDrills(drills));
	} catch (e) {
		throw e;
	}
};

export const getTeamDatedDrills = (date) => async (dispatch) => {
	try {
		// all must be omitted (not false): the backend treats any present value as truthy
		// and would return every drill; the dated branch also returns prefixed keys
		const drills = await trainingAPI.getDrills(date, date, null);
		const normalized = drills.map((d) => ({
			drill_id: d.drill_id__drill_id,
			name: d.drill_id__name,
		}));
		await dispatch(setTeamDatedDrills(normalized));
	} catch (e) {
		throw e;
	}
};

export const getTeamPositions = () => async (dispatch) => {
	try {
		const { positions, sport } = await trainingAPI.getPositions();
		const isObjectArray = positions.length > 0 && typeof positions[0] === "object";
		await dispatch(setTeamPositions(isObjectArray ? positions.map((p) => p.position_name) : positions));
		await dispatch(setPositionEntities(isObjectArray ? positions.map((p) => ({ id: String(p.position_id), name: p.position_name })) : []));
		await dispatch(setTeamSport(sport));
	} catch (e) {
		throw e;
	}
};

export const getAllPositions = () => async (dispatch) => {
	try {
		const { positions } = await trainingAPI.getPositions(true);
		const isObjectArray = positions.length > 0 && typeof positions[0] === "object";
		await dispatch(setAllPositions(isObjectArray ? positions.map((p) => p.position_name) : positions));
	} catch (e) {
		throw e;
	}
};

export const getTeamPlayerGroups = () => async (dispatch) => {
	try {
		const playerGroups = await trainingAPI.getPlayerGroups();
		await dispatch(setTeamPlayerGroups(playerGroups));
	} catch (e) {
		throw e;
	}
};

export const getTeamGames = () => async (dispatch) => {
	try {
		const games = await trainingAPI.getAllGames();
		await dispatch(setTeamGames(games));
	} catch (e) {
		throw e;
	}
};

export const getTeamMetrics = () => async (dispatch) => {
	try {
		const metrics = await trainingAPI.getTeamMetrics();
		await dispatch(setTeamMetrics(metrics));
	} catch (e) {
		throw e;
	}
};

export const getTeamColors = () => async (dispatch) => {
	try {
		const { team_colors: colorRefs } = await trainingAPI.getTeamInfo();
		await dispatch(setTeamColorRefs(colorRefs));
	} catch (e) {
		throw e;
	}
};

export const getTeamHasWellness = () => async (dispatch) => {
	try {
		const hasWellness = await trainingAPI.getWellnessTeams();
		await dispatch(setTeamHasWellness(hasWellness));
	} catch (e) {
		throw e;
	}
};

export const getTeamSessions = () => async (dispatch) => {
	try {
		const sessions = await trainingAPI.getTeamSessions();
		await dispatch(setTeamSessions(sessions));
	} catch (e) {
		throw e;
	}
};

export const getTeamDefaultStats = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		if (stats && Object.keys(stats).length > 0) {
			//gps defaults
			dispatch(
				setGPSStatDefaults(
					(stats?.gps || [])
						.concat([undefined, undefined, undefined, undefined])
						.slice(0, 4)
				)
			);

			//testing defaults
			dispatch(setTestingStatDefaults(
				(stats?.testing || [])
				.concat([undefined, undefined, undefined, undefined])
				.slice(0, 4)
			));
			
			//fp defaults
			dispatch(setForceplateStatDefaults(
				(stats?.forceplate || [])
					.concat([undefined, undefined, undefined, undefined])
					.slice(0, 4)
			));

			//player profile defaults
			let statDefaults;
			if (stats?.profile && Array.isArray(stats?.profile) && stats?.profile.length > 0) {
				// if all strings (older version)
				if (stats?.profile.every(stat => typeof stat === "string" || !stat)) {
					
					if (stats?.profile.length === 8) {
						statDefaults = [[...stats?.profile], [...stats?.profile]];
					} else {
						let tempStat = [...stats?.profile];
						tempStat = tempStat.concat(Array(8 - tempStat.length).fill(undefined));
						statDefaults = [[...tempStat], [...tempStat]];
					}
				} 
				// if all arrays (newer version)
				else if (stats?.profile.every(stat => Array.isArray(stat))) {
					if (stats?.profile.length === 2) {
						let tileStat = [...stats?.profile[0]];
						let chartStat = [...stats?.profile[1]];

						if (tileStat.length < 8) {
							tileStat = tileStat.concat(Array(8 - tileStat.length).fill(undefined));
						}

						if (chartStat.length < 8) {
							chartStat = chartStat.concat(Array(8 - chartStat.length).fill(undefined));
						}
						statDefaults = [tileStat, chartStat];
						
					} else {
						let tileStat = [...stats?.profile[0]];
						if (tileStat.length < 8) {
							tileStat = tileStat.concat(Array(8 - tileStat.length).fill(undefined));
						}
						statDefaults = [[...tileStat], [...tileStat]];
					}
				}
			} else {
				statDefaults = [
					[
						undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined,
					],
					[
						undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined,
					]
				];
			}
			dispatch(setPlayerProfileStatDefaults(statDefaults));
			
			//wellness defaults
			dispatch(
				setWellnessStatDefaults(
					(stats?.subjective || [])
						.concat([undefined, undefined, undefined, undefined])
						.slice(0, 4)
				)
			);

			//nutrition defaults
			dispatch(
				setNutritionStatDefaults(
					(stats?.nutrition || [])
						.concat([undefined, undefined, undefined, undefined])
						.slice(0, 4)
				)
			);

			//cognition defaults
			dispatch(
				setCognitionStatDefaults(
					(stats?.cognition || [])
						.concat([undefined, undefined, undefined, undefined])
						.slice(0, 4)
				)
			);


		}
		
	} catch (e) {
		throw e;
	}
};

export const getTeamTestingStatDefaults = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		const testingStatDefaults = (stats?.testing || []).concat([undefined, undefined, undefined, undefined]).slice(0, 4);
		await dispatch(setTestingStatDefaults(testingStatDefaults));
	} catch (e) {
		throw e;
	}
};

export const getTeamForceplateStatDefaults = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		await dispatch(
			setForceplateStatDefaults(
				(stats?.forceplate || [])
					.concat([undefined, undefined, undefined, undefined])
					.slice(0, 4)
			)
		);
	} catch (e) {
		throw e;
	}
};

export const getTeamPlayerProfileStatDefaults = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		let statDefaults;
		if (stats?.profile && Array.isArray(stats?.profile) && stats?.profile.length > 0) {
			// if all strings (older version)
			if (stats?.profile.every(stat => typeof stat === "string" || !stat)) {
				
				if (stats?.profile.length === 8) {
					statDefaults = [[...stats?.profile], [...stats?.profile]];
				} else {
					let tempStat = [...stats?.profile];
					tempStat = tempStat.concat(Array(8 - tempStat.length).fill(undefined));
					statDefaults = [[...tempStat], [...tempStat]];
				}
			} 
			// if all arrays (newer version)
			else if (stats?.profile.every(stat => Array.isArray(stat))) {
				if (stats?.profile.length === 2) {
					let tileStat = [...stats?.profile[0]];
					let chartStat = [...stats?.profile[1]];

					if (tileStat.length < 8) {
						tileStat = tileStat.concat(Array(8 - tileStat.length).fill(undefined));
					}

					if (chartStat.length < 8) {
						chartStat = chartStat.concat(Array(8 - chartStat.length).fill(undefined));
					}
					statDefaults = [tileStat, chartStat];
					
				} else {
					let tileStat = [...stats?.profile[0]];
					if (tileStat.length < 8) {
						tileStat = tileStat.concat(Array(8 - tileStat.length).fill(undefined));
					}
					statDefaults = [[...tileStat], [...tileStat]];
				}
			}
		} else {
			statDefaults = [
				[
					undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined,
				],
				[
					undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined,
				]
			]
		}

		await dispatch(setPlayerProfileStatDefaults(statDefaults));
	} catch (e) {
		throw e;
	}
};
			
export const getWellnessStatDefaults = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		await dispatch(
			setWellnessStatDefaults(
				(stats?.subjective || [])
					.concat([undefined, undefined, undefined, undefined])
					.slice(0, 4)
			)
		);
	} catch (e) {
		throw e;
	}
};

export const getGPSStatDefaults = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		await dispatch(
			setGPSStatDefaults(
				(stats?.gps || [])
					.concat([undefined, undefined, undefined, undefined])
					.slice(0, 4)
			)
		);
	} catch (e) {
		throw e;
	}
};

export const getNutritionStatDefaults = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		await dispatch(
			setNutritionStatDefaults(
				(stats?.nutrition || [])
					.concat([undefined, undefined, undefined, undefined])
					.slice(0, 4)
			)
		);
	} catch (e) {
		throw e;
	}
};

export const getCognitionStatDefaults = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		await dispatch(
			setCognitionStatDefaults(
				(stats?.cognition || [])
					.concat([undefined, undefined, undefined, undefined])
					.slice(0, 4)
			)
		);
	} catch (e) {
		throw e;
	}
};

export const getTeamOverviewDefaults = () => async (dispatch) => {
	dispatch(setTeamLoading({ overviewStats: true }));
	try {
		const stats = await trainingAPI.getDefaultStats();
		await dispatch(setTeamOverviewStats(stats?.overview || []));
	} catch (e) {
		throw e;
	}
	dispatch(setTeamLoading({ overviewStats: false }));
};

export const getTeamRestTravelDates = () => async (dispatch) => {
	try {
		const data = await trainingAPI.getRestTravelDates();
		await dispatch(setTeamRestTravelDates(data));
	} catch (e) {
		throw e;
	}
};

export const getTeamInformation = () => {
	return async (dispatch, getState) => {
		dispatch(setTeamLoading({ info: true }));
		try {
			// Dispatched first: populates auth.currentUser.uuid (Novu subscriber id) —
			// must not queue behind the heavy team-data flood below.
			dispatch(getCurrentUserData());

			await Promise.all([
				// The backend answers 403 on drills without AccessGpsData, and the
				// user's grants arrive in team info, so drills must wait for it.
				dispatch(getTeamInfo()).then(() => { //needed for ACWR table (coachlist, ACWR limits, name)
					const userPermissions = getState().team?.info?.user_permissions;
					if (hasDataPermission(DATA_STREAM_PERMISSIONS.gps.access, userPermissions))
						return dispatch(getTeamDrills()); //needed for getting prediction info
				}),
				dispatch(getTeamPositions()), //needed for ACWR table position filter
				dispatch(getTeamPlayers()), //needed for ACWR table
				dispatch(getAllTeamMetricsByType()), //needed for add prediction dialog
				dispatch(getCalendarTags()), //needed for tag definitions
			]);

			// fire-and-forget api calls
            dispatch(getTeamPlayerGroups());
            dispatch(getTeamHasWellness());
            dispatch(getTeamDefaultStats()); //combines gps, fp, testing, wellness, nutrition, cognition, profile
            dispatch(getTeamGames());
			dispatch(getColorStrategies());
			// The backend authorizes this endpoint on a per-user platform permission,
			// not on the team flag, so gating on the flag alone guarantees a 403 for
			// every user without it. Both values arrive in the same team-info payload.
			const teamInfo = getState().team?.info;
			if (teamInfo?.user_defined_metrics_enabled && teamInfo?.user_permissions?.ViewUserDefinedMetrics)
				dispatch(getUserDefinedMetrics());
			dispatch(getPlayerStatus())
			dispatch(getTeamSessions());

			// const info = await trainingAPI.getTeamInfo();
			// const drills = await trainingAPI.getDrills();
			// const { positions } = await trainingAPI.getPositions();
			// const players = await trainingAPI.getAllPlayers(false);
			// const playerGroups = await trainingAPI.getPlayerGroups();
			// const games = await trainingAPI.getAllGames();
			// const metrics = await trainingAPI.getTeamMetrics();
			// const { colors: colorRefs } = await trainingAPI.getYearTrainings();
			// const hasWellness = await trainingAPI.getWellnessTeams();
			// const testingStatDefaults = (await trainingAPI.getDefaultTestingStats())
			//   .concat([undefined, undefined, undefined, undefined])
			//   .slice(0, 4);
			// const forceplateStatDefaults = (
			//   await trainingAPI.getDefaultForcePlateStats()
			// )
			//   .concat([undefined, undefined, undefined, undefined])
			//   .slice(0, 4);
			// await dispatch(
			//   setTeamInformation({
			//     info,
			//     drills,
			//     positions,
			//     players,
			//     playerGroups,
			//     games,
			//     metrics,
			//     colorRefs,
			//     hasWellness,
			//     testingStatDefaults,
			//     forceplateStatDefaults,
			//   })
			// );
		} catch (e) {
			console.error(e);
		}
		dispatch(setTeamLoading({ info: false }));
	};
};

export const getTeamGPSData = (force_weekly = false) => {
	return async (dispatch, getState) => {
		await dispatch(setTeamLoading({ gps: true }));
		try {
			const { filter } = getState().team;
			const trainings = await trainingAPI.getTrainings({
				start_date: filter.startDate,
				end_date: filter.endDate,
				weekly: filter.showWeekly || force_weekly,
				pos_filter: filter.position,
				player_group: filter.player_group,
				session_filter: filter.session,
				show_predictions: filter.showPredictions,
			});
			dispatch(setTeamTrainings(trainings));

			const practicePlan = await trainingAPI.getPracticePlan(
				filter.startDate,
				filter.endDate
			);
			dispatch(setTeamPracticePlan(practicePlan));
		} catch (e) {
			console.error(e);
		}
		await dispatch(setTeamLoading({ gps: false }));
	};
};

// The last day target date covers both methods: a practice plan or fixed values.
export const getLastDayTargetDate = async () => {
	try {
		const { date } = await trainingAPI.getDayTargetLatestDate();
		return date;
	} catch (e) {
		console.error(e);
		message.error("Error loading the last day target date");
	}
};

export const getTeamDrillCostPerMin = () => {
	return async (dispatch) => {
		try {
			const data = await trainingAPI.getDrillCostPerMin();
			dispatch(setTeamDrillCostPerMin(data));
		} catch (err) {
			console.error(err);
		}
	};
};

export const getPlayerGroups = () => {
	return async (dispatch) => {
		try {
			const data = await trainingAPI.getPlayerGroups();
			dispatch(setTeamInformation(data));
		} catch (err) {
			console.error(err);
		}
	};
};

export const getTeamTestingRadarData = () => {
	return async (dispatch, getState) => {
		await dispatch(setTeamLoading({ testingRadar: true }));
		try {
			const { filter, radarMetrics } = getState().team;
			if (!radarMetrics.every( (metric) => metric?.includes("-"))) {
				throw new Error(`Invalid metric found in radarMetrics list: ${radarMetrics?.join(", ")}`);
			}
			const data = await trainingAPI.getRadarData({
				start_date: filter.startDate,
				end_date: filter.endDate,
				metrics: radarMetrics,
				pos_filter: filter.position,
				player_group: filter.player_group,
				sessions: filter.session
		});
		dispatch(setTeamTestingRadarData(data));
		} catch (e) {
			console.error(e);
		}
		await dispatch(setTeamLoading({ testingRadar: false }));
	};
};

export const getTeamMovementSignatureData = () => {
  return async (dispatch, getState) => {
    await dispatch(setTeamLoading({ fpmsData: true }));
    try {
      const { filter } = getState().team;
      const data = await trainingAPI.getTestingData({
				  start_date: filter.startDate,
					end_date: filter.endDate,
					pos_filter: filter.position,
					stats: filter.forceplateStats ? "Max" : "Avg",
					player_group: filter.player_group || undefined,
					sessions: filter.session,
					metric_type: "forceplate",
					is_movement_sig: true
				}
      );
      dispatch(setTeamFPMSData(data));
    } catch (e) {
      console.error(e);
    }
    await dispatch(setTeamLoading({ fpmsData: false }));
  };
};

export const changeTeamFPMetric = (key, value) => {
	return async (dispatch, getState) => {
		let metrics = [...getState().team.fpMetrics];
		metrics[key] = value;
		await dispatch(setTeamFPMetrics(metrics));
	};
};

export const saveRestTravelDates = (data) => {
	return async (dispatch) => {
		try {
			await trainingAPI.saveRestTravelDates(data);
			await dispatch(getTeamRestTravelDates());
			message.success("Changes Saved");
		} catch (e) {
			message.error("Error");
			console.error(e);
		}
	};
};

export const getCalendarTags = () => async (dispatch) => {
	try {
		const data = await trainingAPI.getCalendarTags();
		dispatch({ type: CALENDAR_TAGS_SET, data });
	} catch (e) {
		throw e;
	}
};

export const createCalendarTag = (tagData) => async (dispatch) => {
	try {
		await trainingAPI.createCalendarTag(tagData);
		await dispatch(getCalendarTags());
		message.success("Tag created");
	} catch (e) {
		const errMsg = e?.response?.data?.label || e?.response?.data?.detail || "Error creating tag";
		message.error(errMsg);
		throw e;
	}
};

export const updateCalendarTag = (id, tagData) => async (dispatch) => {
	try {
		await trainingAPI.updateCalendarTag(id, tagData);
		await dispatch(getCalendarTags());
		message.success("Tag updated");
	} catch (e) {
		const errMsg = e?.response?.data?.label || e?.response?.data?.detail || "Error updating tag";
		message.error(errMsg);
		throw e;
	}
};

export const deleteCalendarTag = (id) => async (dispatch) => {
	try {
		await trainingAPI.deleteCalendarTag(id);
		await dispatch(getCalendarTags());
		message.success("Tag deleted");
	} catch (e) {
		message.error("Error deleting tag");
		throw e;
	}
};

export const getCalendarDayTags = (startDate, endDate) => async (dispatch) => {
	try {
		const data = await trainingAPI.getCalendarDayTags(startDate, endDate);
		dispatch({ type: CALENDAR_DAY_TAGS_SET, data, startDate, endDate });
	} catch (e) {
		throw e;
	}
};

export const bulkUpdateCalendarDayTags = (tagId, assignDates, removeDates) => async (dispatch) => {
	try {
		await trainingAPI.bulkUpdateCalendarDayTags({
			tag_id: tagId,
			assign_dates: assignDates,
			remove_dates: removeDates,
		});
	} catch (e) {
		message.error("Error saving calendar changes");
		throw e;
	}
};

export const validateTeamAndNotify = () => async (dispatch, getState) => {
	const { team } = getState();
	const userPermissions = team?.info?.user_permissions ?? team?.misc?.user_permissions;
	try {
		displayValidationErrorMessages(
			await trainingAPI.validateTeam(),
			Boolean(userPermissions?.ManageExternalDataConnections)
		);
	} catch (error) {
		message.error("Error performing team validation");
	}
};

export const addTeamPlayer = (playerData) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Adding player" }));
		try {
			await trainingAPI.addPlayers(playerData);
			await dispatch(getTeamPlayers());
			message.success("Added the player");
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error adding the player");
			}
		}

		await dispatch(validateTeamAndNotify());

		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const editTeamPlayer = (playerData) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Editing player" }));
		try {
			await trainingAPI.editPlayer(playerData);
			await dispatch(getTeamPlayers());
			message.success("Edited the player");
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error editing the player");
			}
		}

		await dispatch(validateTeamAndNotify());
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const uploadPlayerHeadshot = (playerId, file) => {
	return async (dispatch) => {
		try {
			const headshot_image_url = await trainingAPI.uploadHeadshot(playerId, file);
			// Awaited so both the roster table and the modal preview (both read the
			// live team.allPlayers record) reflect the new headshot before we resolve.
			await dispatch(getTeamPlayers());
			message.success("Headshot updated");
			return headshot_image_url;
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else message.error("Error uploading headshot");
			return null;
		}
	};
};

export const editTeamPlayers = (players) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Editing players" }));
		try {
			await Promise.all(players.map(trainingAPI.editPlayer));
			message.success("Success");
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error editing players");
			}
		}

		await dispatch(validateTeamAndNotify());

		await dispatch(getTeamPlayers());
		const activePlayers = players?.filter(player => !player?.retired) || [];
		await dispatch(setTeamPlayers(activePlayers))
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const uploadBulkPlayers = (file) => {
	return async (dispatch) => {
		await dispatch(
			setTeamLoading({ onboarding: "Uploading players from csv file" })
		);
		try {
			await trainingAPI.uploadPlayerCsv(file);
			message.success("File uploaded successfully");
			await dispatch(getTeamPlayers());
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error uploading file");
			}
		}

		await dispatch(validateTeamAndNotify());

		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const deletePlayer = (player_id) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Deleting player" }));
		try {
			await trainingAPI.deletePlayer(player_id);
			await dispatch(getTeamPlayers());
			message.success("Deleted player successfully");
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error deleting the player");
			}
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const sendWelcomeEmailToPlayer = (player_id) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Sending welcome email" }));
		try {
			await trainingAPI.sendWelcomeEmail(player_id);
			message.success("Welcome email was sent successfully");
			await dispatch(setTeamLoading({ onboarding: null }));
			return true;
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data) {
				message.error(e.response.data);
			} else {
				message.error("Error sending welcome email to the player");
			}
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const deletePlayers = (ids) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Deleting players" }));
		try {
			await Promise.all(ids.map(trainingAPI.deletePlayer));
			await dispatch(getTeamPlayers());
			message.success("Success");
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error deleting players");
			}
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const setMiscConstants = (data) => {
  return {
    type: TEAM_SET_MISC_CONSTANTS,
    data,
  };
};

export const setPermissionUsers = (data) => {
	return {
		type: TEAM_SET_PERMISSION_USERS,
		data,
	};
};

export const getPermissionUsers = () => async (dispatch) => {
	try {
		const users = await trainingAPI.getPermissionsForTeamUsers();
		if (!Array.isArray(users)) throw new Error("platform-permissions did not return a list of users");
		dispatch(setPermissionUsers(users));
	} catch (e) {
		console.error(e);
		message.error("Error fetching users");
	}
};

export const saveUserPermissions = (userId, permissions) => async (dispatch) => {
	try {
		await trainingAPI.updateUserPermissions(userId, permissions);
		// Team info holds the requesting user's own grants, so an admin who edits themselves needs it refreshed too.
		await Promise.all([
			dispatch(getPermissionUsers()),
			dispatch(getTeamInfo()),
			trainingAPI.getMiscellaneousConstants().then((data) => dispatch(setMiscConstants(data))),
		]);
	} catch (e) {
		console.error(e);
		message.error("Error saving user permissions");
	}
};

export const getTeamPresets = (params) => {
	return async (dispatch, getState) => {
		try {
			const presets = await trainingAPI.getPresets(params);
      		dispatch(setTeamPresets(presets))
		} catch (err) {
			console.error(err);
		}
	};
};

export const setTeamPresets = (data) => {
	return {
	  type: TEAM_SET_PRESETS,
	  data,
	};
};

export const getSandboxDashboards = () => {
	return async (dispatch) => {
		try {
			const dashboards = await trainingAPI.listDashboards();
			dispatch({ type: TEAM_SET_SANDBOX_DASHBOARDS, data: dashboards });
		} catch (err) {
			console.error(err);
		}
	};
};

export const getScatterplotData = () => {
	return async (dispatch, getState) => {
		try {

			const {
				scatterplot_filters: { startDate, endDate, xAxisMetric, yAxisMetric, playerSelections, groupByGameDate, useAvgValues }
			} = getState().team;

			const payload = {
				start_date: startDate?.format ? startDate.format("YYYY-MM-DD") : startDate?.split("T")?.[0],
				end_date: endDate?.format ? endDate.format("YYYY-MM-DD") : endDate?.split("T")?.[0],
				x_axis_metric: xAxisMetric,
				y_axis_metric: yAxisMetric,
				player_selection: playerSelections,
				group_by_game_date: groupByGameDate,
				use_avg_values: useAvgValues
			}
			const scatterplotData = await trainingAPI.getScatterplotData(payload);
			dispatch(setScatterplotData(scatterplotData));
		} catch (err) {
			console.error(err);
		}
	};
};

export const setScatterplotFilters = (data) => {
	return {
	  type: TEAM_SET_SCATTERPLOT_FILTERS,
	  data,
	};
};

export const setScatterplotError = (data) => {
	return {
	  type: TEAM_SET_SCATTERPLOT_ERROR,
	  data,
	};
};

export const setScatterplotData = (data) => {
	return {
	  type: TEAM_SET_SCATTERPLOT_DATA,
	  data,
	};
};

export const addTeamCoach = (coachData) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Adding coach" }));
		try {
			await trainingAPI.addCoach(coachData).then(res => {
				message.success(res);
			});
			await dispatch(getTeamInfo());
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error adding coach");
			}
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const editTeamCoach = (coachData) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Editing coach" }));
		try {
			await trainingAPI.editCoach(coachData).then(res => {
				message.success(res);
			});
			await dispatch(getTeamInfo());
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error adding coach");
			}
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};


export const sendWelcomeEmailToCoach = (coachEmail) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Sending welcome email to coach" }));
		try {
			const res = await trainingAPI.sendWelcomeEmailCoach(coachEmail);
			message.success(`${coachEmail}: ${res}`);
			await dispatch(setTeamLoading({ onboarding: null }));
			return true;
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data) {
				message.error(e.response.data);
			} else {
				message.error(`Error sending welcome email to: ${coachEmail}`);
			}
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};


export const deleteCoach = (coachEmail) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Deleting Coach" }));
		try {
			await trainingAPI.deleteCoach(coachEmail);
			message.success(`Successfully deleted coach!`);
			await dispatch(getTeamInfo());
			await dispatch(setTeamLoading({ onboarding: null }));
			return true;
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data) {
				message.error(e.response.data);
			} else {
				message.error(`Error deleting coach ${coachEmail}`);
			}
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const setColorStrategies = (data) => {
	return {
		type: TEAM_SET_COLOR_STRATEGIES,
		data,
	};
};

export const getColorStrategies = () => {
	return async (dispatch) => {
		try {
			const strategies = await trainingAPI.getColorStrategies();
			dispatch(setColorStrategies(strategies));
			return strategies;
		} catch (e) {
			console.error("Error fetching color strategies:", e);
			if (e?.response?.status < 500 && e?.response?.data) {
				message.error(e.response.data);
			} else {
				message.error(`Error fetching color strategies`);
			}
			return [];
		}
	};
};

export const setUserDefinedMetrics = (data) => {
	return {
		type: TEAM_SET_USER_DEFINED_METRICS,
		data,
	};
};

export const getUserDefinedMetrics = () => {
	return async (dispatch) => {
		try {
			const metrics = await trainingAPI.getUserDefinedMetrics();
			dispatch(setUserDefinedMetrics(metrics));
			return metrics;
		} catch (e) {
			console.error("Error fetching user defined metrics:", e);
			// 403 is expected for users without the ViewUserDefinedMetrics
			// permission; this thunk runs on global team load, so surfacing a
			// toast would nag every such user on the home screen.
			if (e?.response?.status === 403) return [];
			const detail = e?.response?.data;
			message.error(typeof detail === "string" ? detail : "Error fetching user defined metrics");
			return [];
		}
	};
};

export const createUserDefinedMetric = (data) => {
	return async (dispatch) => {
		try {
			await trainingAPI.postUserDefinedMetric(data);
			message.success("Metric created");
			await dispatch(getUserDefinedMetrics());
			await dispatch(getAllTeamMetricsByType());
			return true;
		} catch (e) {
			const detail = e?.response?.data;
			message.error(typeof detail === "string" ? detail : "Failed to create metric");
			return false;
		}
	};
};

export const updateUserDefinedMetric = (id, data) => {
	return async (dispatch) => {
		try {
			await trainingAPI.patchUserDefinedMetric(id, data);
			message.success("Metric updated");
			await dispatch(getUserDefinedMetrics());
			await dispatch(getAllTeamMetricsByType());
			return true;
		} catch (e) {
			const detail = e?.response?.data;
			message.error(typeof detail === "string" ? detail : "Failed to update metric");
			return false;
		}
	};
};

export const deleteUserDefinedMetric = (id) => {
	return async (dispatch) => {
		try {
			await trainingAPI.deleteUserDefinedMetric(id);
			message.success("Metric deleted");
			await dispatch(getUserDefinedMetrics());
			await dispatch(getAllTeamMetricsByType());
			return true;
		} catch (e) {
			const detail = e?.response?.data;
			message.error(typeof detail === "string" ? detail : "Failed to delete metric");
			return false;
		}
	};
};

export const updateDifficultyBarConfig = (data) => async (dispatch) => {
  try {
    await trainingAPI.updateDifficultyBarConfig(data);
    dispatch(getTeamInfo());
    return true;
  } catch (error) {
    console.error("Error updating misc constants:", error);
    throw error;
  }
};

export const updateSessionDurationSource = (value) => async () => {
  return trainingAPI.updateSessionDurationSource({ session_duration_source: value });
};

export const updateAcwrThresholdConfig = (data) => async (dispatch) => {
  try {
    await trainingAPI.updateAcwrThresholdConfig(data);
    dispatch(getTeamInfo());
    return true;
  } catch (error) {
    console.error("Error updating ACWR threshold config:", error);
    throw error;
  }
};

export const setAllGpsMetrics = (data) => {
	return {
		type: TEAM_SET_ALL_GPS_METRICS,
		data,
	};
};

export const getAllGpsMetrics = () => {
	return async (dispatch) => {
		try {
			const gpsMetrics = await trainingAPI.getAllGpsMetrics();
			dispatch(setAllGpsMetrics(gpsMetrics));
			return gpsMetrics;
		} catch (e) {
			console.error("Error updating gps metrics:", e);
			throw e
		}
	};
}

export const updateGymMetricColorLogic = (data) => async (dispatch) => {
  try {
    await trainingAPI.updateGymMetricColorLogic(data);
    dispatch(getTeamInfo());
    return true;
  } catch (error) {
    console.error("Error updating forceplate/testing metric color logic:", error);
    throw error;
  }
};

export const setTestingMetricNames = (data) => {
	return {
		type: TEAM_SET_TESTING_METRIC_NAMES,
		data,
	};
};

export const getTestingMetricNames = () => {
	return async (dispatch) => {
		try {
			const metricNames = await trainingAPI.getTestingMetricNames();
			dispatch(setTestingMetricNames(metricNames));
			return metricNames;
		} catch (e) {
			console.error("Error fetching testing metric names:", e);
			throw e;
		}
	};
};

